import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { QuotaAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * SubGroup Renderer
 *
 *
 * @example
 * ```typescript
 * {
 *   field: 'type',
 *   headerName: 'Cliente',
 *   cellRenderer: SubGroupCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
    selector: 'app-sub-group-cell-renderer',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="leading-tight">
        <b class="f-10" *ngIf="subGroupCode">
        {{ subGroupCode }} <br>
        </b>
        <span>{{ params.data?.materialSubGroupName }}</span>
    </div>
  `,
})
export class SubGroupCellRendererComponent implements CellRenderer<QuotaAttributes> {
    @Input() params!: CellRendererParams<QuotaAttributes>;

    get subGroupCode(): string | null {
        return this.params.data?.materialSubGroupCode;
    }
}